export default __webpack_public_path__ + "static/media/i_bus-dbl_gy.7a7c112f.svg";